import React from "react";
import {
  TextField,
  Checkbox,
  FormControlLabel,
  Box,
  Typography,
  IconButton,
  Button,
} from "@mui/material";
import { AddCircle, Remove, RemoveCircle } from "@mui/icons-material";

const FormFields = ({
  schema = {},
  getValue,
  handleChange,
  addArrayItem,
  removeArrayItem,
}) => {
  const getLastFieldName = (fieldPath) => {
    const parts = fieldPath.split(".") 
    return parts[parts.length - 1];} 

  const renderField = (key, field, path = "") => {
    const fieldPath = path ? `${path}.${key}` : key;

     if (Array.isArray(field)) {
          if (typeof field[0] === "string")  
            return (
              <fieldset key={fieldPath} style={{ marginBottom: "16px", padding: "16px" }}>
                <legend>{ getLastFieldName(fieldPath)}</legend>
                <Button
                  variant="outlined"
                   color="success"
                  startIcon={<AddCircle />}
                  onClick={() => addArrayItem(fieldPath)}
                  style={{ marginBottom: "12px" }}
                >
                  Add Item
                </Button>
                {getValue(fieldPath)?.map((item, index) => (
                  <Box key={`${fieldPath}-${index}`} sx={{ display: "flex", alignItems: "center", marginBottom: "8px" }}>
                    <TextField
                      variant="outlined"
                      size="small"
                      fullWidth
                      value={item}
                      onChange={(e) => handleChange(`${fieldPath}[${index}]`, e.target.value)}
                      sx={{ marginRight: 2 }}
                    />
                    <IconButton
                      color="error"
                      onClick={() => removeArrayItem(fieldPath, index)}
                      size="small"
                    >
                      <Remove />
                    </IconButton>
                  </Box>
                ))}
              </fieldset>
            );
          
    
          return (
            <fieldset key={fieldPath} style={{ marginBottom: "16px", padding: "16px" }}>
              <legend>{key}</legend>
              <Button
                variant="outlined"
                color="success"
               startIcon={<AddCircle />}
                onClick={() => addArrayItem(fieldPath)}
                style={{ marginBottom: "12px" }}
              >
                Add Item
              </Button>
              {getValue(fieldPath)?.map((item, index) => (
                <div key={`${fieldPath}-${index}`} style={{ marginBottom: "12px" }}>
                  {Object.entries(item).map(([nestedKey, nestedField]) =>
                    renderField(nestedKey, nestedField, `${fieldPath}[${index}]`)
                  )}
                  <Button
                    variant="outlined"
                    color="error"
                    startIcon={<RemoveCircle />}
                    onClick={() => removeArrayItem(fieldPath, index)}
                    style={{ marginTop: "8px" }}
                  >
                    Remove Item
                  </Button>
                </div>
              ))}
            </fieldset>
          );
        }

    if (typeof field === "object" && field !== null) {
      return (
        <fieldset key={fieldPath} style={{ marginBottom: "16px", padding: "16px" }}>
          <legend>{key}</legend>
          {Object.entries(field).map(([nestedKey, nestedField]) =>
            renderField(nestedKey, nestedField, fieldPath)
          )}
        </fieldset>
      );
    }

    return (
      <div key={fieldPath} style={{ marginBottom: "12px" }}>
        <Typography variant="body1">{key}</Typography>
        {typeof field === "boolean" ? (
          <FormControlLabel
            control={
              <Checkbox
                checked={getValue(fieldPath)}
                onChange={(e) => handleChange(fieldPath, e.target.checked)}
              />
            }
            label={key}
          />
        ) : (
          <TextField
            variant="outlined"
            size="small"
            fullWidth
            value={getValue(fieldPath)}
            onChange={(e) => handleChange(fieldPath, e.target.value)}
          />
        )}
      </div>
    );
  };

  return (
    <Box
      sx={{
        maxHeight: "50vh",
        overflowY: "auto",
        padding: "16px",
        border: "1px solid #ddd",
        borderRadius: "8px",
      }}
    >
      {Object.entries(schema).map(([key, field]) => renderField(key, field))}
    </Box>
  );
};

export default FormFields;
